import { gatewayAmazonConnect } from "../../../../gateways/gatewayAmazonConnect";

export const postFormPorting = async (formDataPayload: Record<string, any>) => {
  try {
    const response = await gatewayAmazonConnect.post("/porting/register", formDataPayload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data.data || response.data;
  } catch (error) {
    console.error("Error al enviar formulario de porting:", error);
    throw error;
  }
};
